import { NgModule, ModuleWithProviders } from '@angular/core';
import { addIcons } from 'ionicons';
import {
  homeOutline,
  restaurant,
  restaurantOutline,
  resizeSharp,
  gridOutline,
  fastFoodOutline,
  layersOutline,
  albumsOutline,
  newspaperOutline,
  bonfireOutline,
  qrCodeOutline,
  briefcaseOutline,
  giftOutline,
  calculatorOutline,
  calendarOutline,
  notificationsOutline,
  helpCircleOutline,
  personCircleOutline,
  podiumOutline,
  personOutline,
  personAddOutline,
  menuOutline,
  logInOutline,
  fileTrayStackedOutline,
  receiptOutline,
  addCircleOutline,
  addOutline,
  removeCircleOutline,
  removeOutline,
  createOutline,
  trashOutline,
  enterOutline,
  refreshOutline,
  refreshCircleOutline,
  printOutline,
  reloadOutline,
  reloadCircleOutline,
  optionsOutline,
  saveOutline,
  closeOutline,
  closeCircle,
  closeCircleOutline,
  chevronBackOutline,
  chevronForwardOutline,
  chevronUpOutline,
  chevronDownOutline,
  chevronUpCircleOutline,
  chevronDownCircleOutline,
  chevronForwardCircleOutline,
  chevronBackCircleOutline,
  arrowBackCircleOutline,
  arrowForwardCircleOutline,
  arrowBackOutline,
  arrowForwardOutline,
  sparklesOutline,
  golfOutline,
  locateOutline,
  mapOutline,
  navigateOutline,
  listOutline,
  listCircleOutline,
  pricetagOutline,
  pricetagsOutline,
  linkOutline,
  linkSharp,
  eyeOutline,
  eyeOffOutline,
  syncCircleOutline,
  syncOutline,
  logOutOutline,
  mailOutline,
  callOutline,
  locationOutline,
  scanCircleOutline,
  lockClosedOutline,
  lockOpenOutline,
  walkOutline,
  bicycleOutline,
  bagAddOutline,
  bagCheckOutline,
  logoPaypal,
  cartOutline,
  starOutline,
  star,
  starHalf,
  starHalfOutline,
  starSharp,
  starHalfSharp,
  ellipsisHorizontal,
  ellipsisVertical,
  ellipsisVerticalOutline,
  ellipsisHorizontalOutline,
  cameraOutline,
  documentsOutline,
  documentOutline,
  checkmarkDoneOutline,
  checkmarkCircleOutline,
  timeOutline,
  searchOutline,
  chatbubbleOutline,
  chatbubbleEllipsesOutline,
  keyOutline,
  logoWebComponent,
  serverOutline,
  peopleOutline,
  filterOutline,
  cashOutline,
  businessOutline,
  cardOutline,
  barChartOutline,
  pencilOutline,
  paperPlaneOutline,
  checkmarkDoneCircleOutline,
  desktopOutline,
  lockClosed,
  informationCircleOutline
} from 'ionicons/icons';

@NgModule({})
export class IonicIconsModule {
  static forRoot(): ModuleWithProviders<IonicIconsModule> {
    addIcons({
      'home-outline': homeOutline,
      'restaurant': restaurant,
      'restaurant-outline': restaurantOutline,
      'resize-sharp': resizeSharp,
      'grid-outline': gridOutline,
      'fast-food-outline': fastFoodOutline,
      'layers-outline': layersOutline,
      'albums-outline': albumsOutline,
      'newspaper-outline': newspaperOutline,
      'bonfire-outline': bonfireOutline,
      'qr-code-outline': qrCodeOutline,
      'briefcase-outline': briefcaseOutline,
      'gift-outline': giftOutline,
      'calculator-outline': calculatorOutline,
      'calendar-outline': calendarOutline,
      'notifications-outline': notificationsOutline,
      'help-circle-outline': helpCircleOutline,
      'person-circle-outline': personCircleOutline,
      'podium-outline': podiumOutline,
      'person-outline': personOutline,
      'person-add-outline': personAddOutline,
      'menu-outline': menuOutline,
      'log-in-outline': logInOutline,
      'file-tray-stacked-outline': fileTrayStackedOutline,
      'receipt-outline': receiptOutline,
      'add-circle-outline': addCircleOutline,
      'add-outline': addOutline,
      'remove-circle-outline': removeCircleOutline,
      'remove-outline': removeOutline,
      'create-outline': createOutline,
      'trash-outline': trashOutline,
      'enter-outline': enterOutline,
      'refresh-outline': refreshOutline,
      'refresh-circle-outline': refreshCircleOutline,
      'print-outline': printOutline,
      'reload-outline': reloadOutline,
      'reload-circle-outline': reloadCircleOutline,
      'options-outline': optionsOutline,
      'save-outline': saveOutline,
      'close-outline': closeOutline,
      'close-circle': closeCircle,
      'close-circle-outline': closeCircleOutline,
      'chevron-back-outline': chevronBackOutline,
      'chevron-forward-outline': chevronForwardOutline,
      'chevron-up-outline': chevronUpOutline,
      'chevron-down-outline': chevronDownOutline,
      'chevron-up-circle-outline': chevronUpCircleOutline,
      'chevron-down-circle-outline': chevronDownCircleOutline,
      'chevron-forward-circle-outline': chevronForwardCircleOutline,
      'chevron-back-circle-outline': chevronBackCircleOutline,
      'arrow-back-circle-outline': arrowBackCircleOutline,
      'arrow-forward-circle-outline': arrowForwardCircleOutline,
      'arrow-back-outline': arrowBackOutline,
      'arrow-forward-outline': arrowForwardOutline,
      'sparkles-outline': sparklesOutline,
      'golf-outline': golfOutline,
      'locate-outline': locateOutline,
      'map-outline': mapOutline,
      'navigate-outline': navigateOutline,
      'list-outline': listOutline,
      'list-circle-outline': listCircleOutline,
      'pricetag-outline': pricetagOutline,
      'pricetags-outline': pricetagsOutline,
      'link-outline': linkOutline,
      'link-sharp': linkSharp,
      'eye-outline': eyeOutline,
      'eye-off-outline': eyeOffOutline,
      'sync-circle-outline': syncCircleOutline,
      'sync-outline': syncOutline,
      'log-out-outline': logOutOutline,
      'mail-outline': mailOutline,
      'call-outline': callOutline,
      'location-outline': locationOutline,
      'scan-circle-outline': scanCircleOutline,
      'lock-closed-outline': lockClosedOutline,
      'lock-open-outline': lockOpenOutline,
      'walk-outline': walkOutline,
      'bicycle-outline': bicycleOutline,
      'bag-add-outline': bagAddOutline,
      'bag-check-outline': bagCheckOutline,
      'logo-paypal': logoPaypal,
      'cart-outline': cartOutline,
      'star-outline': starOutline,
      'star': star,
      'star-half': starHalf,
      'star-half-outline': starHalfOutline,
      'star-sharp': starSharp,
      'star-half-sharp': starHalfSharp,
      'ellipsis-horizontal': ellipsisHorizontal,
      'ellipsis-vertical': ellipsisVertical,
      'ellipsis-vertical-outline': ellipsisVerticalOutline,
      'ellipsis-horizontal-outline': ellipsisHorizontalOutline,
      'camera-outline': cameraOutline,
      'documents-outline': documentsOutline,
      'document-outline': documentOutline,
      'checkmark-done-outline': checkmarkDoneOutline,
      'checkmark-circle-outline': checkmarkCircleOutline,
      'time-outline': timeOutline,
      'search-outline': searchOutline,
      'chatbubble-outline': chatbubbleOutline,
      'chatbubble-ellipses-outline': chatbubbleEllipsesOutline,
      'key-outline': keyOutline,
      'logo-web-component': logoWebComponent,
      'server-outline': serverOutline,
      'people-outline': peopleOutline,
      'filter-outline': filterOutline,
      'cash-outline': cashOutline,
      'business-outline': businessOutline,
      'card-outline': cardOutline,
      'bar-chart-outline': barChartOutline,
      'pencil-outline': pencilOutline,
      'paper-plane-outline': paperPlaneOutline,
      'checkmark-done-circle-outline': checkmarkDoneCircleOutline,
      'desktop-outline': desktopOutline,
      'lock-closed': lockClosed,
      'information-circle-outline': informationCircleOutline
    });

    return {
      ngModule: IonicIconsModule,
    };
  }
}
